// Shared loader for the YouTube IFrame Player API. Wrapping an <iframe>
// with `new window.YT.Player(el, {...})` handles the postMessage handshake
// internally (onStateChange, playVideo/pauseVideo/seekTo) — listening for
// raw postMessage on window without going through this API never receives
// the player's messages at all, since YouTube only talks to a caller that
// completed this handshake.
export function loadYTApi() {
  if (window.YT?.Player) return Promise.resolve();
  if (window._ytApiPromise) return window._ytApiPromise;
  window._ytApiPromise = new Promise(resolve => {
    window.onYouTubeIframeAPIReady = resolve;
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  });
  return window._ytApiPromise;
}
